import React, {Component} from 'react'
import axios from 'axios'

import './App.css';
import './Css/App.css';

import PageHome from './PageHome/'
import { PageHostingTerms, PageHostingPrivacyPolicy } from './PageHostingTerms';
import PageMaps from './PageMaps/'
import {PageManagement} from './PageManagement/'
import { PageLogin, ResetPassword } from './PageLogin/';

import { BrowserRouter as Router,Route,Switch,Redirect } from 'react-router-dom'

import firebase from './Configs/firebase'
import Config from './Configs/staticConfig'


class App extends Component {
    constructor(props){
        super(props)
        this.state = {
            user:null,
        }

        this.setUser = this.setUser.bind(this)
    }

    componentDidMount(){
        firebase.auth().onAuthStateChanged(user=>{
            this.setUser(user)
        })
    }

    setUser(user){
        if( user === null ){
            return this.setState({user:null})
        }
        var data = {}
        firebase.firestore().collection('users').doc(user.uid).get()
        .then(userRecord=>{
            if( !userRecord.exists ){
                var body = { uid:user.uid }
                return axios.post(Config.getCreateUserByEmailDocUrl(),body)
            }
            else return userRecord
        })
        .then((userRecord)=>{
            if( userRecord.exists ){
                return userRecord          
            }
            else{
                return firebase.firestore().collection('users').doc(user.uid).get()
            }
        })
        .then((userRecord)=>{
            data = userRecord.data()
            data.uid = user.uid
            data.photoURL = user.photoURL
            if( data.hosting === undefined ){
                var phone = prompt("กรุณาใส่กรอกเบอร์โทรศัพท์ : ","08xxxxxxxx")
                if(phone === null || phone === '08xxxxxxxx') throw new Error('กรุณากรอกเบอร์โทรศัพท์')
                data.phone = phone
                return firebase.firestore().collection('users').doc(user.uid).update({
                    available_storage:3221225472,
                    total_storage:3221225472,
                    hosting:true,
                    phone:phone
                })
            }
        })
        .then(()=>{
            if( data.hosting === undefined ){
                return firebase.firestore().collection('users').doc(user.uid).get()
            }
            return null
        })
        .then((userRecord)=>{
            if (userRecord !== null ){
                data = userRecord.data()
                data.uid = user.uid
                data.photoURL = user.photoURL
            }
            this.setState({user:data})
        })
        .catch(err=>{
            this.setState({user:null})
            alert(err)
        })
    }

    render() {
        const { user } = this.state
        var userRouter = null 
        var redirect = null
        if( user === null ){
            redirect = <Route path="/(gis|mymap)" render={() => (<Redirect to ="/login" />)} />
            userRouter = <Route exact path='/(login|mymap)' render={({match,history})=><PageLogin match={match} history={history} setUser={this.setUser} user={user}{...this.props}/>}/>
        }
        else if(user !== null){
            redirect = <Route path="/login" render={() => (<Redirect to='/mymap' />)} />          
            userRouter = <Route exact path="/mymap" render={({match,history})=><PageMaps match={match} history={history} user={user}{...this.props}/>} />                        
        }
        return ( 
            <Router>
                <Switch>
                    <Route exact path='/' render={({match,history})=><PageHome match={match} history={history} user={user}{...this.props}/>} />
                    <Route exact path='/upload/terms' render={({match,history})=><PageHostingTerms match={match} history={history} user={user}{...this.props}/>} />
                    <Route exact path='/upload/privacy_policy' render={({match,history})=><PageHostingPrivacyPolicy match={match} history={history} user={user}{...this.props}/>} />
                    <Route exact path='/plan/:planId' render={({match,history})=><PageMaps match={match} history={history} user={user}{...this.props}/>} />
                    <Route exact path='/drone/:droneId' render={({match,history})=><PageMaps match={match} history={history} user={user}{...this.props}/>} />
                    { redirect }
                    { userRouter }
                    <Route exact path='/resetpassword' render={({match,history})=><ResetPassword match={match} history={history} user={user}{...this.props}/>} />
                    <Route exact path='/gis' render={({match,history})=><PageManagement match={match} history={history} setUser={this.setUser} user={user}{...this.props}/>}/>
                </Switch>
            </Router>
        )
    }
}

export default App


// WEBPACK FOOTER //
// ./src/App.js